import { Component, input, TemplateRef, viewChild } from '@angular/core';

@Component({
  selector: 'ideals-tab',
  template: '<ng-template><ng-content/></ng-template>',
})
export class TabComponent {
  readonly dataIdeals = input('', { alias: 'data-ideals' });
  readonly label = input.required<string>();

  readonly template = viewChild.required(TemplateRef);
}
